export const projectData = [
    {
        id: 1,
        image: 'tripsight-img',
        projectTitle: "Tripsight",
        projectDescription: "Tripsight is a MERN stack application that is a one stop shop for all things travel, content, pictures for planning future travel or just getting your fix of far off places! It allows the user to create an account, post blogs and search other users blogs.",
        projectLanguages: 'React, Node.Js, MongoDB, Mongoose, GraphQL, Apollo, JavaScript and Sass',
        githubLink:'https://github.com/travel-app-devs/TripSight',
        deployedLink: 'https://tripsight.herokuapp.com/',
    },
    {
        id: 2,
        image: 'good-neghibor-image',
        projectTitle: 'Good Neighbor',
        projectDescription: 'GoodNeighbor is a web app that is based solely on the idea of people helping people around their communities, based on Pyotr Kropotkin Mutual Aid.  With the web app you are able to exchange services and messages via the dashboard when you create an account. This app is built with full CRUD fuctionality and uses MYSQL for the database.',
        projectLanguages: 'JavaScript, Node.js, MySQL, Express, Sequelize, Handlebars, CSS and Bootstrap',
        githubLink: 'https://github.com/Northwestern-Coding-Bootcamp-Project-2/GoodNeighbor',
        deployedLink: 'https://thegoodneighbor.herokuapp.com/',
    },
    {
        id: 3,
        image:'domu',
        projectTitle: 'Domu',
        projectDescription: 'Domu is a neighborhood restaurant and bar that offered house made noodles, creative takes on small plates and seasonal cocktails. I decided to take on this personal project and redesign there current site. I felt that I could give a diferent design spin on it, improve the user experience and a more friendly experience.',
        projectLanguages: 'JavaScript, CSS, HTML and Bootstrap',
        githubLink:'https://github.com/itiskchengs/Domu_Project',
        deployedLink:'https://itiskchengs.github.io/Domu_Project/',
    }
];
